import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { changeQuantity } from "./cartSlice";

import {ReactComponent as MinusIcon} from '../../assets/images/icons/minus.svg';
import {ReactComponent as PlusIcon} from '../../assets/images/icons/plus.svg';


export const QuantitySelector = ({id}) => {
    const item = useSelector(state => state.cart.cart).find(item => item.id === id);
    const dispatch = useDispatch();
   
  

    const [quantity, setQuantity] = useState(parseFloat(item.qty) || 1);
    const [inputInit, setInit] = useState(false);

    const increment = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setQuantity(prevQuantity => prevQuantity + 1);
    }
    
    const decrement = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setQuantity(prevQuantity => prevQuantity > 1 ? prevQuantity - 1 : 0);
    }
    
    useEffect(() => {
        if (inputInit) {
            dispatch(changeQuantity({id: item.id, qty: quantity}));
        } else {
            setInit(true);
        } 
    }, [quantity]);

    return (
        <div className="quantity-selector">
            <MinusIcon  onClick={decrement}/>
            <div onClick={(e) => {e.preventDefault(); e.stopPropagation()}} className="value">{quantity}</div>
            <PlusIcon  onClick={increment}/>
        </div>
    )
}